import { UserInfo } from '@Entities/user/user'
import { analytics } from '@App/configs/segment-config'

export const analyticsSendPage = (pageName: string) => {
    analytics.page(pageName)
}

export const analyticsSendEvent = (eventName: string) => {
    analytics.track(eventName)
}

export const analyticsSendIdentify = (user: UserInfo) => {
    if (user && user.exposedId) {
        window.dataLayer.push({
            event: 'identify-user',
            mlcUserId: user.exposedId,
            username: user.firstName + ' ' + user.lastName,
            userFirstName: user.firstName,
            userLastName: user.lastName,
            userEmail: user.email,
            userCreatedAt: user.invitedAt,
        })

        analytics.identify(user.exposedId, {
            name: user.firstName + ' ' + user.lastName,
            email: user.email,
            created_at: user.invitedAt,
        })
    }
}
